/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { UpdateUserNotificationSettingRequestNotificationSetting } from './UpdateUserNotificationSettingRequestNotificationSetting';
import {
    UpdateUserNotificationSettingRequestNotificationSettingFromJSON,
    UpdateUserNotificationSettingRequestNotificationSettingFromJSONTyped,
    UpdateUserNotificationSettingRequestNotificationSettingToJSON,
} from './UpdateUserNotificationSettingRequestNotificationSetting';

/**
 * 
 * @export
 * @interface UpdateUserNotificationSettingRequest
 */
export interface UpdateUserNotificationSettingRequest {
    /**
     * 
     * @type {UpdateUserNotificationSettingRequestNotificationSetting}
     * @memberof UpdateUserNotificationSettingRequest
     */
    notificationSetting: UpdateUserNotificationSettingRequestNotificationSetting;
}

/**
 * Check if a given object implements the UpdateUserNotificationSettingRequest interface.
 */
export function instanceOfUpdateUserNotificationSettingRequest(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "notificationSetting" in value;

    return isInstance;
}

export function UpdateUserNotificationSettingRequestFromJSON(json: any): UpdateUserNotificationSettingRequest {
    return UpdateUserNotificationSettingRequestFromJSONTyped(json, false);
}

export function UpdateUserNotificationSettingRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserNotificationSettingRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'notificationSetting': UpdateUserNotificationSettingRequestNotificationSettingFromJSON(json['notification_setting']),
    };
}

export function UpdateUserNotificationSettingRequestToJSON(value?: UpdateUserNotificationSettingRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'notification_setting': UpdateUserNotificationSettingRequestNotificationSettingToJSON(value.notificationSetting),
    };
}

